import { render, staticRenderFns } from "./formFile.vue?vue&type=template&id=b0db4b02&scoped=true"
import script from "./formFile.vue?vue&type=script&lang=js"
export * from "./formFile.vue?vue&type=script&lang=js"
import style0 from "./formFile.vue?vue&type=style&index=0&id=b0db4b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0db4b02",
  null
  
)

export default component.exports